import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';

function NewsItem({ news, handleClickNews, handleDuplicateNews }) {
  return (
    <div
      className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44"
      onClick={handleClickNews}>
      <div className="flex flex-col justify-around h-full w-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">{news.title}</div>
          <span className="font-medium text-slate-700">
            {moment(news.publication_date).format('LL')}
          </span>
        </div>
        <div className="flex flex-row gap-x-3">
          {news.tags?.map((t, index) => (
            <Tag
              key={index}
              tag={{
                label: news.t?.label,
                icon: 'person',
                bgColor: 'bg-orange-800'
              }}
            />
          ))}
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className="min-h-12 min-w-12"
        tooltip="Dupliquer l'article"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateNews}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default NewsItem;
